import React, { useEffect, useState } from "react";
import { Select } from "antd";
import styled from "styled-components";

// Styled component for the Select dropdown
const StyledSelect = styled(Select)`
  &.custom-selector {
    z-index: 1 !important;
    width: 100%;
    .ant-select-selector {
      background-color: ${(props) => props.bgColor || "#fbf7fb"};
      color: ${(props) => props.fontColor || "gray"};
      height: ${(props) => props.height || "48px"} !important;
      border-radius: 5px !important;
      border-radius: ${(props) =>
        props.mainSearch ? "0px" : "5px"} !important;
      border-color: #eee !important;
      transition: all 0.3s ease;
      // font-weight: 500;
      &:hover {
        cursor: pointer;
      }
      ${(props) =>
        props.isFocused &&
        `
        box-shadow: none !important;
        ${'' /* background-color: white !important; */}
        border-color: ${(props) => props.bgColor || "#fbf7fb"};
      `}
    }

    .ant-select-selection-placeholder {
      // color: #5e5e5e !important;
      color: ${(props) => (props.condition == "true" ? "#ECECED" : "#5e5e5e")};
      font-weight: ${(props) => (props.condition == "true" ? "500" : "")};
      text-align: start;
      margin-left: 10px;
    }
    .ant-select-arrow {
      color: ${(props) => props.fontColor || "gray"};
      margin-top: ${(props) => (props.height ? "-2px" : "unset")};
      font-weight: 500;
    }
  }

  .custom-dropdown {
    background-color: #36424e;
    color: gray !important;
    box-shadow: none !important;

    .ant-select-dropdown {
      box-shadow: none !important; /* Remove shadow */
    }
    .ant-select-item {
      color: white;

      &:hover {
        background-color: #485666;
      }

      &.ant-select-item-option-selected {
        background-color: #576b7d;
        font-weight: 500;
      }
    }
  }
`;

const CustomSelector = ({
  options,
  placeholder,
  deviceName,
  setDeviceName,
  comparison,
  defaultValue,
  onChange,
  style,
  category,
  size,
  height,
  bgColor,
  fontColor,
  value,
  mainSearch,
  bikes,
  condition,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };
  return (
    <StyledSelect
      showSearch
      allowClear
      placeholder={placeholder}
      value={value}
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      category={category}
      size={size ? size : "large"}
      height={height}
      bgColor={bgColor}
      fontColor={fontColor}
      // value={deviceName}
      className="custom-selector"
      // onChange={handleChange}
      onChange={onChange}
      options={options}
      style={{ cursor: "pointer", ...style }}
      dropdownClassName="custom-dropdown"
      onFocus={handleFocus}
      onBlur={handleBlur}
      isFocused={isFocused}
      mainSearch={mainSearch}
      bikes={bikes}
      condition={condition}
    />
  );
};

export default CustomSelector;
